import { takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import alertify from 'alertify.js';

import { fetchApi } from '../utils/api';

import {
    contactSuccess,
    contactFailure,

    bookSessionSuccess,
    bookSessionFailure,

    getStatsSuccess,
    getStatsFailure,

    getGeneralPageSuccess,
    getGeneralPageFailure,

    getAppBrandSuccess,
    getAppBrandFailure
} from './globalActions';

const {
    CONTACT_REQUEST,
    BOOK_SESSION_REQUEST,
    GET_STATS_REQUEST,
    GET_GENERAL_PAGE_REQUEST,
    GET_APP_BRAND_REQUEST
} = require('./globalActions').constants;

/**
 * submit contact request to server
 */
function* doContact(action) {
    try {
        const response = yield call(fetchApi, {
            method: 'POST',
            url: '/page/contact-us',
            body: action.payload
        });

        yield put(contactSuccess(response));
        alertify.alert('Your message has been sent.');
    } catch (e) {
        alertify.error(e.response ? e.response.data.message : e);
        yield put(contactFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * submit book session request to server
 */
function* doBookSession(action) {
    try {
        const response = yield call(fetchApi, {
            method: 'POST',
            url: '/page/book-session',
            body: action.payload
        });

        yield put(bookSessionSuccess(response));
        alertify.alert('Your booking request has been sent.');
    } catch (e) {
        alertify.error(e.response ? e.response.data.message : e);
        yield put(bookSessionFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * fetch system stats
 * @return {Generator} [description]
 */
function* fetchStats() {
    try {
        const response = yield call(fetchApi, {
            method: 'get',
            url: 'page/stats'
        });

        yield put(getStatsSuccess(response));
    } catch (e) {
        yield put(getStatsFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

/**
 * fetch general page
 * @return {Generator} [description]
 */
function* fetchPage(action) {
    try {
        const response = yield call(fetchApi, {
            method: 'get',
            url: `page/${action.payload.name}`
        });

        yield put(getGeneralPageSuccess({
            name: action.payload.name,
            data: response.data.details
        }));
    } catch (e) {
        yield put(getGeneralPageFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

/**
 * fetch app branding
 * @return {Generator} [description]
 */
function* fetchAppBrand() {
    try {
        const response = yield call(fetchApi, {
            method: 'get',
            url: 'page/app-brand'
        });

        yield put(getAppBrandSuccess(response));
    } catch (e) {
        yield put(getAppBrandFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* globalSaga() {
    yield* [
        takeLatest(CONTACT_REQUEST, doContact),
        takeLatest(BOOK_SESSION_REQUEST, doBookSession),
        takeLatest(GET_STATS_REQUEST, fetchStats),
        takeLatest(GET_GENERAL_PAGE_REQUEST, fetchPage),
        takeLatest(GET_APP_BRAND_REQUEST, fetchAppBrand)
    ];
}



/** WEBPACK FOOTER **
 ** ./src/core/global/globalSaga.js
 **/